module.exports = __webpack_public_path__ + "static/banner-b7ef77771121da1fe0903a6da5a84bcc.png";